import React, { useEffect, useState } from 'react'
import { useAuth } from '../context/AuthContext.jsx'
import { useSearchParams } from 'react-router-dom'

export default function LikedPage() {
  const { user, tokens } = useAuth()
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (!tokens?.accessToken) return
    setLoading(true)
    fetchLikedVideos()
  }, [tokens])

  const fetchLikedVideos = async () => {
    try {
      const res = await fetch('/api/videos/user/liked/', {
        headers: { Authorization: `Bearer ${tokens.accessToken}` }
      })
      const data = await res.json()
      if (data.success) {
        setVideos(data.data.videos)
      }
    } catch (e) {
      console.error('Failed to fetch liked videos:', e)
    } finally {
      setLoading(false)
    }
  }

  const formatDuration = (sec) => {
    if (!sec) return '0:00'
    const m = Math.floor(sec / 60)
    const s = sec % 60
    return `${m}:${s.toString().padStart(2, '0')}`
  }

  const formatViews = (count) => {
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`
    if (count >= 1000) return `${(count / 1000).toFixed(1)}K`
    return count.toString()
  }

  const formatTimeAgo = (date) => {
    const now = new Date()
    const then = new Date(date)
    const diffMs = now - then
    const diffMins = Math.floor(diffMs / 60000)
    if (diffMins < 60) return `${diffMins} minutes ago`
    const diffHours = Math.floor(diffMins / 60)
    if (diffHours < 24) return `${diffHours} hours ago`
    const diffDays = Math.floor(diffHours / 24)
    return `${diffDays} days ago`
  }

  if (!user) {
    return (
      <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
        <div>
          <h2>Sign in to see your liked videos</h2>
        </div>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 1800, margin: '0 auto', padding: '24px 20px' }}>
      <h1 style={{ marginBottom: 24, fontSize: 28, fontWeight: 600 }}>Liked Videos</h1>
      {loading ? (
        <div style={{ minHeight: '40vh', display: 'grid', placeItems: 'center' }}>
          <p>Loading…</p>
        </div>
      ) : videos.length === 0 ? (
        <div style={{ minHeight: '40vh', display: 'grid', placeItems: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            <p style={{ fontSize: 16, color: 'var(--muted)', marginBottom: 8 }}>No liked videos yet</p>
            <p style={{ fontSize: 14, color: 'var(--muted)' }}>Videos you like will appear here</p>
          </div>
        </div>
      ) : (
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(320px, 100%), 1fr))', 
          gap: 16 
        }}>
          {videos.map(video => (
            <div
              key={video.id}
              onClick={() => setSearchParams({ v: video.id })}
              style={{ cursor: 'pointer', display: 'grid', gap: 12 }}
            >
              <div style={{ position: 'relative', paddingBottom: '56.25%', background: '#000', borderRadius: 12, overflow: 'hidden' }}>
                {video.thumbnail ? (
                  <img src={video.thumbnail} alt={video.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <div style={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center', color: '#666' }}>No thumbnail</div>
                )}
                <div style={{ position: 'absolute', bottom: 8, right: 8, background: 'rgba(0,0,0,0.8)', color: '#fff', padding: '2px 6px', borderRadius: 4, fontSize: 12, fontWeight: 600 }}>
                  {formatDuration(video.duration)}
                </div>
              </div>
              <div style={{ display: 'grid', gap: 4 }}>
                <h3 style={{ fontSize: 15, fontWeight: 600, lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{video.title}</h3>
                <div style={{ fontSize: 13, color: 'var(--muted)' }}>
                  {formatViews(video.viewCount)} views • {formatTimeAgo(video.likedAt || video.createdAt)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
